<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length ? '没有更多了' : ''"
      @load="onLoad"
    >
      <template v-if="list.length">
        <item v-for="(item, index) in list" :key="index" :item="item" :type="2"></item>
      </template>
      <van-empty v-else description="暂无信息" />
    </van-list>
  </van-pull-refresh>
</template>
<script>
import { getSubscribePost, plateList, getSubPostIds } from '@/api/base';
import item from '../components/item';
export default {
  components: { item },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      page: {
        rows: 10,
        current: 1,
        scrollid: null,
      },
      list: [],
      subPostIds: [],
    };
  },
  created() {
    getSubPostIds({ openId: window.openId }).then(res => {
      this.subPostIds = res.data;
    });
  },
  methods: {
    async onLoad() {
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: '...',
      // });
      let infos = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      console.log(infos);
      let obj = {
        filter: { sectionCode: null, field: 'author', type: null },
        query: {
          indexname: 'post',
          keyWords: infos.userName,
          rows: 10,
          current: this.page.current,
          scrollid: this.page.scrollid,
          sort: 'lastupdatetime',
        },
        openId: 'oFQ7G5vJ1X0v-YHs4eROQUIAVNFU',
      };
      plateList(obj)
        .then(res => {
          // res.data.data.map(item => {
          //   item.subscribe = true;
          // });
          res.data.data.map(item => {
            return (item.subscribe = this.subPostIds.indexOf(item.id) != -1 ? true : false);
          });
          let tmpList = res.data.data;
          let list = this.list || [];
          if (this.refreshing) {
            list = tmpList;
            this.refreshing = false;
          } else if (tmpList.length) {
            list = [...list, ...tmpList];
          } else {
            this.finished = true;
          }
          this.loading = false;

          this.list = this.insertAndSort(list);
          // this.list = list;
          this.page.scrollid = res.data.scrollid;
          this.page.current++;
          // this.$toast.clear();
        })
        .catch(error => {
          this.finished = true;
          this.loading = false;
        });
    },
    onRefresh() {
      this.list = [];
      this.refreshing = true;
      this.finished = false;
      this.page = { current: 1, size: 10, scrollid: null };
      this.onLoad();
    },
    insertAndSort(list) {
      console.log(list);
      let locList = JSON.parse(window.localStorage.getItem('createPostList')) || [];
      console.log(locList);
      // 过滤出在B中不存在的ID并将它们插入到B数组的前面
      const arr = [];
      locList.forEach(item => {
        if (!list.find(b => b.postId === item.postId)) {
          arr.unshift(item);
        }
      });
      arr.push(...list); // 将原始B数组中的剩余项添加到新数组的末尾
      // 根据createTime字段进行倒序排序
      const sortedItems = [...arr].sort(
        (a, b) => new Date(b.lastupdatetime) - new Date(a.lastupdatetime),
      );
      console.log(sortedItems);
      return sortedItems;
    },
  },
};
</script>
